import { render } from "./UserReplacementMocDetails.vue?vue&type=template&id=012e5df7&scoped=true"
import script from "./UserReplacementMocDetails.vue?vue&type=script&lang=js"
export * from "./UserReplacementMocDetails.vue?vue&type=script&lang=js"

import "./UserReplacementMocDetails.vue?vue&type=style&index=0&id=012e5df7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012e5df7"]])

export default __exports__